import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import {Router} from '@angular/router';
import { ProductStatistics } from '../../../../services/api-product.service';
import { OrderWindow } from '../../../../models/order-window.model';
import { OrderService } from '../../../../services/order.service';
import { DATE_FORMAT } from 'app/constants/date-format';

@Component({
    selector: 'app-header-callout',
    templateUrl: './header-callout.component.html',
    styleUrls: ['./header-callout.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})

export class HeaderCalloutComponent {
    public defaultDateMonthYearFormat = DATE_FORMAT.SHORT_DAY_MONTH_FORMAT;

    @Input() statistics: ProductStatistics = {};

    @Input() orderWindow: OrderWindow;

    constructor(
        private orderService: OrderService,
        private router: Router
    ) {}
    get formattedDates( ): string {
        if (!this.orderWindow?.start_at || !this.orderWindow?.end_at) {
            return '';
        }

        const timezone = this.orderWindow.timezone || 'UTC';

        return `${this.orderWindow.start_at.formatInTimezone(timezone, 'DD MMM YYYY HH:mm')} - ${this.orderWindow.end_at.formatInTimezone(timezone, 'DD MMM YYYY HH:mm')}`;
    }

    get timezoneLabel(): string {
        if (!this.orderWindow) {
            return '';
        }

        return this.orderWindow.timezone || 'UTC';
    }

    selectActiveWindow() {
        if (this.router.url === '/') {
            // for home page - switch order window - otherwise do redirect to buying windows programs
            this.orderService.switchActiveOrderWindow( );
        } else {
            const activeBuyingWindow = this.orderService.findLastActiveOrder();
            if (activeBuyingWindow) {
                this.router.navigate(['/buying-window', activeBuyingWindow.id, 'programs']);
            }
        }
    }
}
